<div class="flex flex-col w-full h-full">
    <!-- Header -->
    <div mat-dialog-title class="flex flex-0 items-center justify-between h-12">
        <div class="text-lg font-medium">Invoice <b>{{view.itin?.content?.itinerary?.reference}}</b></div>
        <button mat-icon-button (click)="close()" [tabIndex]="-1">
            <mat-icon class="text-current" [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
        </button>
    </div>

    <mat-dialog-content class="p-2 flex flex-col min-h-0" style="max-height: 100%;">
        @if (loading) {
            <div class="flex flex-1 items-center justify-center py-8 text-secondary">Loading invoice…</div>
        } @else if (invoiceHtml) {
            <div class="flex-1 overflow-auto min-h-[400px]" [innerHTML]="invoiceHtml"></div>
        } @else {
            <iframe class="flex-1 min-h-[400px]" [src]="view.quoteViewUrl" width="100%" height="100%" frameBorder="0"></iframe>
        }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <mat-form-field appearance="fill" class="min-w-[160px] mr-auto mb-0">
            <mat-label>Brand</mat-label>
            <mat-select [(value)]="selectedBrand" (selectionChange)="onBrandChange($event.value)">
                <mat-option [value]="11">AndGo</mat-option>
                <mat-option [value]="19">OnHoliday</mat-option>
            </mat-select>
        </mat-form-field>

        <button mat-button mat-dialog-close>Close</button>
        <button mat-flat-button [disabled]="true">
            <span class="inline-flex items-center"><mat-icon class="mr-1.5 icon-size-5"
                    [svgIcon]="'mat_outline:share'"></mat-icon> Share</span>
        </button>
        <a mat-flat-button cdkFocusInitial [href]="view.quoteDownloadUrl" target="_blank">
            <span class="inline-flex items-center"><mat-icon class="mr-1.5 icon-size-5"
                    [svgIcon]="'mat_outline:file_download'"></mat-icon> Download</span>
        </a>
    </mat-dialog-actions>
</div>